import { defineStore } from "pinia";
import { stopService, planService } from "@/_services";
export const stopStore = defineStore("stop", {
  state: () => ({
    stops: null,
    stopsExport: null,
    stop: null,
    stopAudit: null,
    stopDateUpdated: null,
    stopAddressNormalizedUpdated: null,
    stopTimeWindowUpdated: null,
    stopUnassigned: null,
    stopDeleted: null,
    unassignedStops: null,
    manualStopCreated: null,
    manualStopUpdated: null,
    error: null,
    customFilterDate: null,
  }),

  actions: {
    clear() {
      this.stops = null;
      this.stopsExport = null;
      this.stop = null;
      this.stopAudit = null;
      this.stopDateUpdated = null;
      this.stopAddressNormalizedUpdated = null;
      this.stopTimeWindowUpdated = null;
      this.stopUnassigned = null;
      this.stopDeleted = null;
      this.unassignedStops = null;
      this.manualStopCreated = null;
      this.manualStopUpdated = null;
      this.error = null;
      this.customFilterDate = null;
    },
    setCustomFilterDate(value){
      this.customFilterDate= value;
    },
    getStops(pagination, query, sort) {
      this.error = null;
      stopService
        .getStops(pagination, query, sort)
        .then((result) => {
          this.stops = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    exportar(pagination, query, sort) {
      this.error = null;
      this.stopsExport = null;
      return stopService
        .exportar(pagination, query, sort)
        .then((result) => {
          this.stopsExport = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    getStopById(stopId) {
      this.error = null;
      this.stop = null;
      return stopService
        .getStopById(stopId)
        .then((result) => {
          const source = result?.data || result || null;
          this.stop = source;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    getStopAudit(stopId) {
      this.stopAudit = null;
      this.error = null;
      stopService
        .getStopAudit(stopId)
        .then((result) => {
          this.stopAudit = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    updateStopDate(stopIdOrIds, payload) {
      this.error = null;
      this.stopDateUpdated = null;
      const normalizedStopIds = Array.isArray(stopIdOrIds)
        ? stopIdOrIds.filter(Boolean).join(",")
        : stopIdOrIds;

      stopService
        .updateStopDate(normalizedStopIds, payload)
        .then((result) => {
          this.stopDateUpdated = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    retryDelivery(stopIdOrIds, payload) {
      this.error = null;
      this.stopDateUpdated = null;
      const normalizedStopIds = Array.isArray(stopIdOrIds)
        ? stopIdOrIds.filter(Boolean).join(",")
        : stopIdOrIds;

      return stopService
        .retryDelivery(normalizedStopIds, payload)
        .then((result) => {
          this.stopDateUpdated = result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    updateStopAddressNormalized(stopId, payload) {
      this.error = null;
      this.stopAddressNormalizedUpdated = null;
      stopService
        .updateStopAddressNormalized(stopId, payload)
        .then((result) => {
          this.stopAddressNormalizedUpdated = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    updateStopTimeWindow(stopsIds, payload) {
      this.error = null;
      this.stopTimeWindowUpdated = null;
      const normalizedStopsIds = Array.isArray(stopsIds) ? stopsIds.join(",") : stopsIds;
      stopService
        .updateStopTimeWindow(normalizedStopsIds, payload)
        .then((result) => {
          this.stopTimeWindowUpdated = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    unassignStops(planId, routeId, routeStopIds) {
      this.error = null;
      this.stopUnassigned = null;

      const normalizedRouteStopIds = Array.isArray(routeStopIds) ? routeStopIds : [routeStopIds];
      const stopsIdsCsv = normalizedRouteStopIds.filter(Boolean).join(",");
      return planService
        .unassignRouteStop(planId, routeId, stopsIdsCsv)
        .then((result) => {
          this.stopUnassigned = result;
        })
        .catch((reason) => {
          this.error = reason;

        });
    },
    deleteStop(stopId) {
      this.error = null;
      this.stopDeleted = null;
      return stopService
        .deleteStop(stopId)
        .then((result) => {
          this.stopDeleted = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    createManualStop(payload) {
      this.error = null;
      this.manualStopCreated = null;
      return stopService
        .createManualStop(payload)
        .then((result) => {
          this.manualStopCreated = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    updateManualStop(stopId, payload) {
      this.error = null;
      this.manualStopUpdated = null;
      return stopService
        .updateManualStop(stopId, payload)
        .then((result) => {
          this.manualStopUpdated = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    downloadManualExcelTemplate() {
      this.error = null;
      return stopService
        .downloadManualExcelTemplate()
        .then((result) => result)
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    getUnassignedStopsForKanban(date, type) {
      this.error = null;
      return stopService
        .getUnassignedStops(date, type)
        .then((result) => {
          this.unassignedStops = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
  },
});
